export const normalizeQuoteSearchText = (value = "") => String(value ?? "").toLowerCase().trim()
  .replace(/[^a-z0-9\s@._-]+/g, " ").replace(/\s+/g, " ");

// Descriptors are shared by the query adapter and acceptance/reference tests.
// No substring scans: names/sites are prefixes; token searches are exact tokens.
export function quoteSearchPlan(text) {
  const normalized = normalizeQuoteSearchText(text);
  if (normalized.length < 2) return [];
  const raw = String(text).trim();
  if (/^ac-\d{4}-\d+$/i.test(raw)) return ["quoteNo", "quoteNoString"].map(field => ({ field, kind: "exact", value: raw.toUpperCase() }));
  if (raw.startsWith("id:") && raw.length > 3 && !raw.slice(3).includes("/") && ![".", ".."].includes(raw.slice(3))) return [{ field: "__name__", kind: "exact", value: raw.slice(3) }];
  if (/^crm-lead-[a-z0-9-]+$/.test(raw)) return [{ field: "__name__", kind: "exact", value: raw }];
  const number = raw.match(/^[a-z]{1,3}-?\d+/i)?.[0]?.toUpperCase() || raw;
  const jobs = [
    ...["quoteNo", "quoteNoString"].map(field => ({ field, kind: "prefix", value: number })),
    ...["customerNameLower", "projectNameLower", "siteNameLower", "quoteDisplayTitleLower", "companyNameLower", "normalizedEmail"]
      .map(field => ({ field, kind: "prefix", value: normalized })),
    ...["searchKeywords", "searchTokens"].map(field => ({ field, kind: "token", value: normalized })),
  ];
  const compact = normalized.replace(/[^a-z0-9]+/g, "");
  if (/^\d+$/.test(compact)) jobs.push({ field: "normalizedPhone", kind: "prefix", value: compact.slice(-10) }, { field: "customerPhone", kind: "prefix", value: compact });
  return jobs;
}

export function quoteSearchMatches(record, text) {
  const normalized = normalizeQuoteSearchText(text);
  if (/^ac-\d{4}-\d+$/i.test(String(text).trim())) return [record.quoteNo, record.quoteNoString].some(value => normalizeQuoteSearchText(value) === normalized);
  if (String(text).trim().startsWith("id:")) return record.id === String(text).trim().slice(3);
  if (/^crm-lead-[a-z0-9-]+$/.test(String(text).trim())) return record.id === String(text).trim();
  if ([record.quoteNo, record.quoteNoString, record.customerNameLower, record.projectNameLower, record.siteNameLower,
    record.quoteDisplayTitleLower, record.companyNameLower, record.normalizedEmail].some(value => typeof value === "string" && normalizeQuoteSearchText(value).startsWith(normalized))) return true;
  if ([record.searchKeywords, record.searchTokens].some(values => Array.isArray(values) && values.includes(normalized))) return true;
  const digits = normalized.replace(/[^a-z0-9]+/g, "");
  return /^\d+$/.test(digits) && [record.normalizedPhone, record.customerPhone].some(value => String(value || "").startsWith(digits.slice(-10)));
}
